import React from 'react'
import { Provider } from 'react-redux'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { applyMiddleware, createStore, compose, combineReducers } from 'redux'
import thunk from 'redux-thunk'

import { GoogleOAuthProvider } from '@react-oauth/google'

import App from './App'

import authReducer from './store/reducers/authReducer'
import historyReducer from './store/reducers/historyReducer'

import './styles/main_global.scss'
import { UiState } from 'context/ui'

const composeEnhancers =
  process.env.NODE_ENV === 'production'
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const rootReducer = combineReducers({
  auth: authReducer,
  history: historyReducer,
})

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))

const root = createRoot(document.getElementById('root'))

root.render(
  <GoogleOAuthProvider
    clientId={
      process.env.REACT_APP_GOOGLE_ID ||
      `762923432718-9ifhiu7igag6c2902uh9nejfo28uuc69.apps.googleusercontent.com`
    }
  >
    <Provider store={store}>
      <Router>
        <UiState>
          <App />
        </UiState>
      </Router>
    </Provider>
  </GoogleOAuthProvider>,
)
